/**
 * Clears every store that holds account data, so nothing from one session is visible to the
 * next user of the same tab. Called whenever the signed-in user goes away or changes.
 */

import { useAccountStore } from "./accountStore";
import { useCampaignStore } from "./campaignStore";
import { useContactAttributeDefinitionStore } from "./contactAttributeDefinitionStore";
import { useContactListStore } from "./contactListStore";
import { useContactStore } from "./contactStore";
import { useCustomBlocksStore } from "./customBlocksStore";
import { useEmailBuilderStore } from "./emailBuilderStore";
import { useMediaStore } from "./mediaStore";
import { useTemplatesStore } from "./templatesStore";

export function resetUserData(): void {
  useAccountStore.getState().reset();
  useCampaignStore.getState().reset();
  useContactAttributeDefinitionStore.getState().reset();
  useContactListStore.getState().reset();
  useContactStore.getState().reset();
  useCustomBlocksStore.getState().reset();
  useEmailBuilderStore.getState().reset();
  useMediaStore.getState().reset();
  useTemplatesStore.getState().reset();
}
